export default __webpack_public_path__ + "img/membership_banner1-f9a0372a904e75d8bcfe48984bebeeab.jpg";